import { createContext, useContext } from 'react';
import { t } from './translations';

const LanguageContext = createContext('he');

export const LanguageProvider = ({ lang, children }) => {
  return (
    <LanguageContext.Provider value={lang}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);

export const useTranslation = () => {
  const lang = useContext(LanguageContext);
  return { lang, t: t(lang), isEnglish: lang === 'en' };
};

export default LanguageContext;
